import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const SelectBut=styled.button`
  background-color: ${Variables.colors.complementary_250};
  width: 160px;
  height: 38px;
  border-radius: 4px;
  border: none;
  position: relative;
  padding: 8px;
  font-size: ${Variables.font_sizes.x_medium};
  line-height:23px;
  text-align: right;
  cursor: pointer;
  &:focus {
    border-bottom: 2px solid ${Variables.colors.primary_vivid};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
export const Box = styled.div`
  font-family: Number, sans-serif;
  position: relative;
  width: 160px;
  i.calendar-icon {
    cursor: pointer;
    position: absolute;
    right: 130px;
    top: 10px;
    color: ${props =>
      props.iconStaus
        ? Variables.colors.primary_vivid
        : Variables.colors.complementary_700};
    &:before {
      font-size: 16px;
    }
  }
  .react-datepicker__input-container {
    input {
      background-color: ${Variables.colors.complementary_250};
      width: 160px;
      height: 38px;
      border-radius: 4px;
      border: none;
      position: relative;
      padding: 8px;
      font-size: ${Variables.font_sizes.x_medium};
      &:focus {
        border-bottom: 2px solid ${Variables.colors.primary_vivid};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      &:before {
        content: "dddddd";
        position: absolute;
        height: 30px;
        width: 80%;
        background-color: ${Variables.colors.complementary_250};
        z-index: 1;
      }
    }
  }
  .react-datepicker-popper {
    transform: none !important;
    right: 0;
    top: 30px !important;
    .react-datepicker__triangle {
      display: none;
    }
    .react-datepicker {
      width: auto !important;
      border: none;
      border-radius: 4px;
      box-shadow: 0 2px 8px 0 #cccccc;
      .react-datepicker__navigation {
        border: none;
        height: 22px;
        width: 15px;
        top: 18px;
        &:before {
          font-family: "MapsaIcon";
          color: ${Variables.colors.complementary_900};
          display: block;
          text-indent: 0;
          font-size: 12px;
        }
      }
      .react-datepicker__navigation--previous {
        left: 60px;
        &:before {
          content: "\\eadc";
        }
      }
      .react-datepicker__navigation--next {
        right: auto;
        left: 20px;
        &:before {
          content: "\\ead6";
        }
      }
      .react-datepicker__month-container {
        font-family: Number, sans-serif;
        .react-datepicker__header {
          background-color: ${Variables.colors.complementary};
          border: none;
          .react-datepicker__current-month {
            text-align: right;
            padding-right: 12px;
            padding-top: 16px;
          }
          .react-datepicker__day-names {
            margin-bottom: -10px;
            margin-top: 8px;
            font-size: ${Variables.font_sizes.small};
            .react-datepicker__day-name {
              color: ${Variables.colors.complementary_700};
              width: 2.48rem;
              line-height: 1.8rem;
            }
          }
        }
        .react-datepicker__day {
          border-radius: 20px;
          margin: 0.166rem 0.4rem;
          width: 2rem;
          line-height: 2rem;
        }
        .react-datepicker__day--today {
          background-color: ${Variables.colors.primary_100};
          color: ${Variables.colors.primary_vivid};
        }
        .react-datepicker__day--fri {
          color: ${Variables.colors.primary_vivid};
        }
        .react-datepicker__day--selected {
          background-color: ${Variables.colors.primary_vivid};
          color: ${Variables.colors.complementary};
        }
      }
    }
  }
  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.red_600};
  }
`;
